module.exports = __webpack_public_path__ + "img/msg3.bbe196a9.png";